export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {eyebrow && <p className="eyebrow text-gold-dark">{eyebrow}</p>}
      <h1 className="mt-1 text-3xl sm:text-4xl font-bold tracking-tight text-navy" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-slate-600">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Panel = ({ title, action, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-xl border bg-white shadow-sm ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b px-5 py-4">
        <h2 className="font-display text-base font-semibold text-navy">{title}</h2>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Empty = ({ children, testId }) => (
  <p data-testid={testId} className="px-5 py-10 text-center text-sm text-slate-500">{children}</p>
);
